import { Flex } from '#UNSAFE_Flex';
import { ComponentChildren, JSX } from 'preact';
import { valueSlotStyles } from './LabelValueLayoutStyles.css';

type Props = {
  flexAlign: 'stretch' | 'start';
  labelStyleClasses?: string;
  labelStyles?: JSX.CSSProperties;
  labelInnerClasses?: string;
  label: ComponentChildren;
  valueStyles?: JSX.CSSProperties;
  children?: ComponentChildren;
};

/**
 * StyledLabelValueLayout is a styled layout component for displaying a label and its corresponding value.
 */
export const StyledLabelValueLayout = ({
  flexAlign,
  labelStyleClasses,
  labelStyles,
  labelInnerClasses,
  label,
  valueStyles,
  children
}: Props) => {
  return (
    <Flex wrap="wrap" align={flexAlign}>
      <div class={labelStyleClasses} style={labelStyles}>
        <div class={labelInnerClasses}>{label}</div>
      </div>
      <div class={valueSlotStyles} style={valueStyles}>
        {children}
      </div>
    </Flex>
  );
};
